export const initialState: any = {
  eventsUpdates: [],
  delayUpdates: [],
};
